import 'reflect-metadata';
import { Container, ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { patsnapCopilotModule } from '@/services/patsnap-copilot-module';
import { businessModule } from '@/container-modules/business-module';
import { componentsModule } from '@/container-modules/components-module';
import { baseModule } from '@/container-modules/base-module';
import { serviceApiModule } from '@/container-modules/service-api-module';

export const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(new ContainerModule(patsnapCopilotModule));
container.load(baseModule);
container.load(businessModule);
container.load(componentsModule);
container.load(serviceApiModule);
